<template>
  <div id="app">
    <router-view id="content"></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',
  metaInfo: () => ({
    link: [{ rel: "favicon", href: "favicon.ico" }],
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Basel Academy",
    // all titles will be injected into this template
    description: "Die Basel Academy ist ein wissenschaftliches Institut und Dienstleister in den Bereichen Qualitätsmessung, Versorgungsforschung und klinische Forschung.",
  }),
}
</script>

<style lang="scss">
</style>
